import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'releaseDate'
})
export class ReleaseDatePipe implements PipeTransform {
  transform(releaseDate: any, args?: any): string {
    if (!releaseDate) {
      return 'In progress';
    } else if (releaseDate.startsWith('3')) {
      return 'In QA3';
    } else {
      return releaseDate;
    }
  }
}
